import React, { useState, useContext } from "react";
import styled from "styled-components";
import { memberSystemLink } from "api";
import media from "cssMix/index";
import { GiHamburgerMenu } from "react-icons/gi";
import { ContextStore } from "Reducer";
import cx from "classnames";
// import { IoIosSearch } from "react-icons/io"
import Avatar from "./Avatar";
import AvatarPopup from "./AvatarPopup";
import ReactModal from "Components/common/ReactModal";

import useMediaQuery from "useHooks/useMediaQuery";
// util
import { gameLinkLang } from "Utils/index";

export default ({
  t,
  dispatch,
  hamHandler,
  currency,
  balance,
  handleRefreshClick,
  userInfo,
  account,
  avatarList,
  mainAreaRoute,
  homeScrollTop,
  refresh,
}) => {
  const {
    state: { stateReducer },
  } = useContext(ContextStore);
  const lang = stateReducer.get("lang");
  const hasCQ9VIPClub = stateReducer.get("hasCQ9VIPClub");
  const [avatarPopup, setAvatarPopup] = useState(false);
  const { mediaType } = useMediaQuery();
  const avatarPopHandler = () => {
    setAvatarPopup(!avatarPopup);
  };
  const userAvatar = userInfo.get("avatar")
    ? userInfo.get("avatar") === ""
      ? "1"
      : userInfo.get("avatar")
    : "1";

  const logoClickHandler = () => {
    dispatch({ type: "CHANGE_DATA", path: "mainAreaRoute", value: "Lobby" });
  };
  const memberClickHandler = () => memberSystemLink(gameLinkLang(lang));
  return (
    <Logo balance={balance}>
      <div className="logo">
        <div>
          <img alt="" src={`images/logo.gif`} onClick={logoClickHandler} />
          {mediaType !== "pc" && hasCQ9VIPClub && (
            <img
              className="memberSystem"
              alt=""
              src={`images/icon.png`}
              onClick={memberClickHandler}
            />
          )}
        </div>
        <GiHamburgerMenu onClick={hamHandler} />
      </div>
      {mainAreaRoute !== "PayoutRank" && mainAreaRoute !== "PlayerRank" && (
        <div className="amount-area">
          <div>
            <div className="currency">{currency}</div>
            <div className="balance">
              <p>{balance}</p>
              <div
                className={cx([
                  "bx bx-refresh gav2_btn_balance",
                  {
                    refresh: refresh,
                  },
                ])}
                style={{
                  fontSize: "24px",
                  color: "#f9be00",
                  cursor: "pointer",
                }}
                onClick={handleRefreshClick}
              />
              <div
                className={cx([
                  "coin",
                  {
                    refresh: refresh,
                  },
                ])}
              />
            </div>
          </div>
          <div>
            <Avatar
              userAvatar={userAvatar}
              avatarPopHandler={avatarPopHandler}
              account={account}
              handleRefreshClick={handleRefreshClick}
              balance={balance}
              currency={currency}
              avatarList={avatarList}
            />
            <ReactModal
              isOpen={avatarPopup}
              onModalClose={() => setAvatarPopup(false)}
            >
              <AvatarPopup
                t={t}
                avatarPopHandler={avatarPopHandler}
                userAvatar={userAvatar}
                dispatch={dispatch}
                avatarList={avatarList}
              />
            </ReactModal>
          </div>
        </div>
      )}
      <FixedBalance className={homeScrollTop > 150 && "fixed"}>
        <div className="currency">{currency}</div>
        <div className="balance">
          <p>{balance}</p>
          <div
            className={cx([
              "bx bx-refresh gav2_btn_balance",
              {
                refresh: refresh,
              },
            ])}
            style={{
              fontSize: "24px",
              color: "#fff",
              cursor: "pointer",
            }}
            onClick={handleRefreshClick}
          />
          <div
            className={cx([
              "coin",
              {
                refresh: refresh,
              },
            ])}
          />
        </div>
      </FixedBalance>
      <div className="line" />
    </Logo>
  );
};
const FixedBalance = styled.div`
  display: none;
  transition: all 1s ease;
  &.fixed {
    ${media.tablet`
  bottom: 20px;
  opacity:1 ;
  `}
  }
  ${media.tablet`
  display: flex;
  opacity:0;
  color: #fff;
  z-index: 9;
  height: 40px;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  bottom: -50px;
  width: calc(100% - 32px);
  box-sizing: border-box;
  padding: 9px;
  border: solid 1px rgba(249, 190, 0, 0.5);
  background-color: rgba(249, 190, 0, 0.3);
  backdrop-filter: blur(10px);
  border-radius: 8px;
  & .currency {
    font-size: 12px;
    font-weight: 500;
  }
  & .balance {
    position:relative;
    & > p {
      margin-right: 10px;
    }
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
  }
  `}
`;
const Logo = styled.div`
  width: 100%;
  margin-bottom: 40px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
  @keyframes coin {
    0% {
      bottom: 0;
      opacity: 0;
    }
    50% {
      bottom: 25px;
      opacity: 1;
    }
    100% {
      bottom: 0;
      opacity: 0;
    }
  }
  & .bx {
    z-index: 1;
    &.refresh {
      animation: rotate 0.7s ease-in-out;
    }
  }
  & .coin {
    display: block;
    width: 25px;
    height: 25px;
    position: absolute;
    bottom: 0;
    right: 0;
    transform: translateY(-50%);
    background-image: url("images/coin.gif");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0;
    &.refresh {
      animation: coin 1s ease forwards;
    }
  }
  & .amount-area {
    display: none;
  }
  .line {
    width: 100%;
    height: 1px;
    margin: 60px 0 0;
    opacity: 0.3;
    background-color: #fff;
  }
  .logo {
    display: flex;
    width: 100%;
    justify-content: center;
    color: #ffffff;
    > div > img {
      width: 120px;
      cursor: pointer;
    }
    & > svg {
      display: none;
    }
  }
  .searchIcon {
    display: none;
    width: 34px;
    height: 34px;
    color: ${({ theme }) => theme.colors["13"]};
    cursor: pointer;
  }
  .amount-avatar {
    display: none;
  }
  ${media.tablet`
    margin-bottom:0;
    display:flex;
    align-items:center;
    justify-content:center;
    background: url("images/bg_mobile.png") no-repeat, #12110f;
    background-size:cover ;
    .line{
      display:none;
    }
    .logo{
      align-items:center;
      justify-content:space-between;
      margin-bottom:10px;
      height:50px;
      width:100%;
      >div >img {
        width: 70px;
      }
      .memberSystem{
        width: 30px;
        margin-left: 10px;
      }
    & > svg {
      display: block;
      width: 20px;
      height: 20px;
      cursor:pointer;
    }
    }
    .searchIcon{
        display:block;
        position:absolute;
        right:0;
    }
    & .account{
     display:none;
   }
   & .amount-area{
    display: flex;
    width:100%;
    height:75px;
    align-items:center;
    justify-content:space-between;
    & .currency {
      font-size: 12px;
      font-weight: 600;
      color: #fff;
    }
    & .balance {
      position:relative ;
      display:flex;
      align-items:center;
      & > p {
        font-size: ${(props) => (props.balance.length > 20 ? "24px" : "28px")};
        font-weight: 600;
        color:#fff;
        margin:0;
        margin-right:5px;
      }
    }
   }
    `}
`;
